// Central UI copy. German-only for v1; the shape is `t.<key>` so swapping
// to react-i18next later only touches the resolver, not call sites.

export const t = {
  // Board controls
  addRow: "Zeile",
  addRowCreated: "Zeile erstellt.",
  addRowDialogTitle: "Zeile hinzufügen",
  addRowDialogDescription: "Felder ausfüllen und erstellen. Pflichtfeld ist der Titel.",
  addRowDialogNoFields: "Dieses Board hat keine ausfüllbaren Felder.",
  addRowDialogCreate: "Erstellen",
  addRowDialogSaveAndNew: "Speichern und neu",
  addGroupButton: "Neue Gruppe",
  addGroupPlaceholder: "Gruppenname",
  addGroupConfirm: "OK",
  addColumn: "Spalte hinzufügen",
  columnResizeHint: "Ziehen zum Anpassen · Doppelklick: an Inhalt anpassen",
  addColumnTitle: "Neue Spalte",
  addColumnDescription:
    "Lege eine Spalte für dieses Board an. Status-Spalten können mehrere Optionen mit Farben haben.",
  columnName: "Name",
  columnNamePlaceholder: "z. B. Budget",
  columnType: "Spaltentyp",
  statusOptions: "Optionen",
  addOption: "Option hinzufügen",
  removeOption: "Option entfernen",
  statusOptionColor: "Farbe wählen",
  statusOptionRole: "Rolle im Ticket-Workflow",
  statusRoleNone: "— keine",
  statusRoleHint:
    "Rollen verknüpfen eine Option mit den Ticket-Aktionen (Annehmen, Lösen …) — unabhängig vom angezeigten Namen.",
  renameColumn: "Umbenennen",
  renameColumnTitle: "Spalte umbenennen",
  renameColumnDescription: "Wähle einen neuen Namen. Die Daten in den Zeilen bleiben erhalten.",
  deleteColumn: "Spalte löschen",
  deleteColumnTitle: "Spalte wirklich löschen?",
  deleteColumnMessage:
    '„{name}" und alle Werte in dieser Spalte werden entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
  columnDeletedToast: "Spalte gelöscht.",
  share: "Teilen",
  filter: "Filtern",
  filterNoColumns: "Keine filterbaren Spalten auf diesem Board.",
  filterClear: "Filter zurücksetzen",
  filterContains: "enthält …",
  filterAll: "Alle",
  filterChecked: "Erledigt",
  filterUnchecked: "Offen",
  filterBefore: "vor dem",
  filterAfter: "nach dem",
  filterEmpty: "Leer",
  filterEmptyHint: "Nur Zeilen ohne (gültigen) Wert anzeigen",
  sort: "Sortieren",
  sortNone: "Keine Sortierung",
  sortTicketId: "Ticket-ID",
  group: "Gruppieren",
  groupedBy: "Gruppiert nach Status",
  groupByNone: "Keine Gruppierung",
  fields: "Felder",
  searchRows: "Zeilen suchen",
  table: "Tabelle",
  kanban: "Kanban",
  calendar: "Kalender",
  timeline: "Zeitleiste",
  pinBoard: "Anheften",
  unpinBoard: "Anheftung entfernen",
  unpinBoardAria: "Aus angeheftet entfernen",

  // Cells
  assign: "Zuweisen",
  tags: "Schlagwörter",
  link: "Link",
  attach: "Anhängen…",
  addNotes: "Notizen…",
  setStatus: "Status wählen",
  newOption: "Neue Option…",
  titleEmpty: "—",
  addTextHint: "+ Hinzufügen",
  openChip: "Öffnen",
  selected: "ausgewählt",
  status: "Status",
  archive: "Archivieren",
  delete: "Löschen",
  rowDeleted: "Zeile gelöscht – mit Strg+Z rückgängig",
  rowsDeleteTitle: "Zeilen löschen?",
  rowsDeleteMessage:
    "Die ausgewählten Zeilen werden gelöscht. Du kannst dies mit Strg+Z rückgängig machen.",
  // Mobile single-row delete — no Strg+Z on a phone, so the message doesn't promise an undo.
  rowDeleteTitle: "Zeile löschen?",
  rowDeleteMessage: "Diese Zeile wird gelöscht.",

  // Dashboard / shell
  recent: "Zuletzt verwendet",
  yourWorkspaces: "Deine Workspaces",
  homeRequest: "Anfrage stellen",
  homeIdea: "Idee einreichen",
  ideaPickerSubtitle: "Teile deine Idee mit dem Unternehmen.",
  homeMyTickets: "Meine Tickets",
  homeMyTicketsSub: "Deine Tickets an andere Abteilungen",
  homeOpenTickets: "Offene Tickets & Aufgaben",
  homeOpenTicketsSub: "Eingehend an dein Team + dir zugewiesen",
  homeCalendarShow: "Kalender",
  homeCalendarHide: "Kalender ausblenden",
  homeCalendarTitle: "Diese Woche",
  homeCalendarSub: "Deine terminierten Aufgaben (Mo–Fr)",
  homeCalendarNone: "frei",
  homeMyBoards: "Meine Boards",
  homeNoMyTickets: "Du hast noch keine Anfrage gestellt.",
  homeNoOpenWork: "Nichts Offenes – alles erledigt.",
  homeNoDeadlineGroup: "Ohne Frist",
  chipTicket: "Ticket",
  chipTask: "Aufgabe",
  workspaceIconMenuItem: "Symbol ändern",
  teamsWebhookMenuItem: "Teams-Benachrichtigungen",
  teamsWebhookMenuItemActive: "Teams-Benachrichtigungen ✓",
  teamsWebhookTitle: "Teams-Webhook — {name}",
  teamsWebhookDescription:
    "Neue Tickets dieser Abteilung werden in den verknüpften Teams-Kanal gepostet. Incoming-Webhook-URL aus Teams einfügen.",
  teamsWebhookLabel: "Webhook-URL",
  teamsWebhookHint: "Teams › Kanal › Connectors › Incoming Webhook",
  teamsWebhookPlaceholder: "https://… .webhook.office.com/…",
  teamsWebhookPlaceholderConfigured: "Konfiguriert — neue URL einfügen zum Ersetzen",
  teamsWebhookSaved: "Teams-Webhook gespeichert.",
  teamsWebhookCleared: "Teams-Webhook entfernt.",
  teamsWebhookClear: "Entfernen",
  workspaceIconTitle: "Symbol für {name}",
  workspaceIconDescription: "Wähle ein Symbol für diesen Workspace.",
  workspaceIconSaved: "Symbol gespeichert",
  workspaceIconNone: "Initialen",
  workspaceIconNoneHint: "Standard – zeigt die Initialen",
  viewingNow: "sehen mit",
  viewingNowOne: "sieht mit",
  detailResizeAria: "Detailbreite anpassen (ziehen)",
  rteLink: "Link",
  rteLinkPrompt: "Link-URL",

  // Dates
  today: "Heute",
  tomorrow: "Morgen",
  yesterday: "Gestern",
  days: "Tage",
  daysDative: "Tagen",
  in: "in",
  overdue: "überfällig",
  resolvedLate: "verspätet",
  ticketAgeOpenPrefix: "seit",
  ticketResolvedPrefix: "gelöst in",

  // Misc
  offline: "Du bist offline — Änderungen werden synchronisiert, sobald du wieder online bist",
  signIn: "Mit LogicLine SSO anmelden",
  signingIn: "Anmelden …",
  members: "Mitglieder",
  rowsCount: "Zeilen",
  boardCount: "Boards",

  // Row detail
  comment: "Kommentar hinzufügen …",
  closeEsc: "Schließen (Esc)",
  detailExpand: "Große Ansicht",
  detailCollapse: "Andocken",
  copyLink: "Verknüpfung kopieren",
  followAria: "Folgen — bei Updates benachrichtigt werden",
  unfollowAria: "Abonniert — nicht mehr folgen",
  more: "Mehr",

  // Comments / activity feed
  commentsTitle: "Verlauf",
  timelineToday: "Heute",
  timelineYesterday: "Gestern",
  commentsEmpty: "Noch keine Kommentare",
  commentSend: "Senden",
  commentSendHint: "Strg+Enter zum Senden",
  // 🔴 Shown IN the composer, not as a tooltip on the send button. Shift+Enter has always
  // inserted a line break and the break has always survived the save — but the only place that
  // said so was a `title=` nobody hovers, so a colleague asked for a feature that already
  // existed. The same shape as the column "⋯" menu, the drag handles and "+ Untereintrag":
  // capability present, affordance invisible, reported as missing.
  composerKeyHint: "Umschalt+Enter für Zeilenumbruch · Strg+Enter zum Senden",
  commentSendFailed: "Kommentar konnte nicht gesendet werden.",
  commentAttachFile: "Datei anhängen",
  commentFileUploading: "Wird hochgeladen …",
  commentFileFailed: "Datei konnte nicht hochgeladen werden.",
  commentFileTooLarge: "Datei ist zu groß (max. 100 MB).",
  commentFileType: "Dieser Dateityp wird nicht unterstützt.",
  commentFileMax: "Maximal 10 Dateien pro Kommentar.",
  commentFileRemove: "Entfernen",
  commentDropHint: "Datei hier ablegen",
  commentDelete: "Kommentar löschen",
  moreActions: "Weitere Aktionen",
  duplicate: "Duplizieren",
  duplicateWithComments: "Mit Kommentaren duplizieren",
  copyIncludeComments: "Kommentare mitkopieren",
  rowDuplicated: "Zeile dupliziert",
  commentEdit: "Kommentar bearbeiten",
  commentLike: "Gefällt mir",
  commentUnlike: "Gefällt mir nicht mehr",
  commentReply: "Antworten",
  commentReplyTo: "Antwort auf",
  commentReplyPlaceholder: "Antworten …",
  commentReplySend: "Antworten",
  commentEditSave: "Speichern",
  commentEditCancel: "Abbrechen",
  commentDeleteTitle: "Kommentar löschen?",
  commentDeleteMessage:
    "Der Kommentar wird endgültig entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  commentAuthorUnknown: "Gelöschter Nutzer",
  notificationCommented: "Neuer Kommentar",

  // Calendar / timeline
  rowsWithDate: "Zeilen mit Datum",
  timelineResizeTitleCol: "Spaltenbreite anpassen",
  calMonth: "Monat",
  calWeek: "Woche",
  impliedStarts: 'Implizite Startdaten · 7 Tage vor „Fällig"',

  // Login
  welcomeBack: "Willkommen zurück",
  signInToFlow: "Anmelden bei Flow",
  ssoBlurb:
    "Verwende dein LogicLine-Konto. Du wirst zu unserem SSO weitergeleitet und nach erfolgreicher Anmeldung zurückgebracht.",
  termsBlurb: "Mit der Anmeldung akzeptierst du die internen LogicLine-Nutzungsrichtlinien.",
  problemsLogin: "Probleme bei der Anmeldung?",
  contactIt: "IT kontaktieren",
  hostedOn: "gehostet auf",

  // Dashboard
  greetingMorning: "Guten Morgen",
  greetingDay: "Hallo",
  greetingEvening: "Guten Abend",
  boardsUpdated: "3 Boards aktualisiert seit deinem letzten Besuch.",

  stats: {
    assignedToMe: "Mir zugewiesen",
    dueThisWeek: "Diese Woche fällig",
    activeBoards: "Aktive Boards",
    sharedWithYou: "Mit dir geteilt",
    overdueCount: "3 überfällig",
    in2Boards: "in 2 Boards",
    fourWorkspaces: "4 Workspaces",
    plusTwoToday: "+2 heute",
  },

  // Workspace filters
  filtersAll: "Alle",
  filtersMine: "Meine",
  filtersPinned: "Angeheftet",
  filtersArchived: "Archiviert",
  newBoard: "Neues Board",
  workspaces: "Workspaces",

  // Shell
  navHome: "Home",
  navWorkspace: "Workspace",
  navDesignSystem: "Design System",
  navPinned: "Angeheftet",
  navTickets: "Tickets",
  navAllBoards: "Boards",
  navSharedGuest: "Geteilt & Gast",
  navBoardsEmpty: "Noch keine Boards",
  undo: "Rückgängig",
  redo: "Wiederholen",
  undoSkippedChanged: "Inzwischen geändert – Rückgängig übersprungen",
  navPostfach: "Mein Postfach",
  navSettings: "Einstellungen",
  railHide: "Seitenleiste ausblenden",
  railShow: "Seitenleiste einblenden",
  searchPlaceholder: "Suchen oder springen…",

  // Mobile tabs
  mobileInbox: "Inbox",
  mobileBoards: "Boards",
  mobileMe: "Mir",
  mobileMore: "Mehr",

  // Row detail meta
  createdBy: "Erstellt von",
  createdLabel: "Erstellt",
  updatedLabel: "Aktualisiert",
  createdAgo: "Erstellt vor 9 Tagen",
  updatedAgo: "Aktualisiert vor 12 Min.",
  addPerson: "Person",
  addDate: "Datum",
  yes: "Ja",
  no: "Nein",

  // Theme toggle
  toggleTheme: "Theme wechseln",
  signOut: "Abmelden",

  // Create dialogs
  create: "Erstellen",
  creating: "Wird erstellt …",
  cancel: "Abbrechen",
  createWorkspaceTitle: "Neuen Workspace anlegen",
  createWorkspaceDescription:
    "Workspaces gruppieren Boards. Wähle einen Namen — den Slug kannst du anpassen oder so lassen.",
  workspaceName: "Name",
  workspaceNamePlaceholder: "z. B. Marketing",
  workspaceSlug: "Slug",
  workspaceSlugHint: "Wird in URLs verwendet. Nur Kleinbuchstaben, Zahlen und Bindestriche.",
  workspaceSlugTaken: "Dieser Slug ist bereits vergeben.",
  createBoardTitle: "Neues Board anlegen",
  createBoardDescription: "Boards bestehen aus Spalten (Typen) und Zeilen mit Werten.",
  boardName: "Name",
  boardNamePlaceholder: "z. B. Q3 Roadmap",
  boardDescription: "Beschreibung",
  boardDescriptionPlaceholder: "Optionale Kurzbeschreibung …",
  boardTemplateLabel: "Vorlage",
  ideaHomeVisibleLabel: "Für alle auf der Startseite sichtbar",
  ideaHomeVisibleHint: "Zeigt einen „Idee einreichen“-Button auf der Startseite aller Mitarbeiter.",
  unknownError: "Unbekannter Fehler — bitte erneut versuchen.",

  // Empty states
  emptyWorkspacesTitle: "Du hast noch keine Workspaces",
  emptyWorkspacesHint: "Leg deinen ersten Workspace an, um Boards zu organisieren.",
  emptyBoardsTitle: "Noch keine Boards",
  emptyBoardsHint: "Erstelle dein erstes Board in diesem Workspace.",
  emptyRecentBoardsTitle: "Du hast noch keine Boards",
  emptyRecentBoardsHint: "Sobald du Boards anlegst, erscheinen die zuletzt verwendeten hier.",
  newWorkspace: "Neuer Workspace",

  // Workspace not found
  workspaceNotFoundTitle: "Workspace nicht gefunden",
  workspaceNotFoundHint:
    "Der Workspace existiert nicht oder du bist kein Mitglied. Gehe zurück zum Dashboard.",
  backToDashboard: "Zurück zum Dashboard",

  // Loading / generic
  loading: "Wird geladen …",
  rowNotFound: "Eintrag nicht gefunden.",
  saving: "Speichern …",
  save: "Speichern",
  confirm: "Bestätigen",
  comingSoon: "Demnächst",
  copyLinkSuccess: "Link kopiert.",
  copyLinkFail: "Konnte nicht kopiert werden.",

  // A lazy part of the page failed to load (lib/chunkRecovery.ts): usually its old build
  // is gone after a deploy, sometimes the connection broke (also without a service worker),
  // so the wording claims neither.
  chunkErrorTitle: "Seite nicht vollständig geladen",
  chunkErrorBody:
    "Ein Teil dieser Seite konnte nicht geladen werden, meist weil Flow inzwischen aktualisiert wurde oder die Verbindung unterbrochen war. Lade die Seite neu, um weiterzuarbeiten.",
  chunkErrorReloading: "Die Seite wird neu geladen …",
  reloadPage: "Neu laden",
  // A new service worker took over this tab (lib/updatePrompt.ts)
  newVersionAvailable: "Neue Version verfügbar",

  // Board card menu / rename / delete
  renameBoard: "Umbenennen",
  renameBoardTitle: "Board umbenennen",
  renameBoardDescription: "Wähle einen neuen Namen für dieses Board.",
  editBoardTitle: "Board bearbeiten",
  editBoardHint: "Name und Beschreibung dieses Boards.",
  duplicateBoard: "Duplizieren",
  duplicateBoardTitle: "Board duplizieren",
  duplicateBoardHint:
    "Erstellt eine Kopie im selben Workspace: Struktur, Einträge, Verantwortliche und Vorlaufzeiten werden übernommen. Der Status wird auf Offen zurückgesetzt; Deadline, Zeitleiste und Dateien bleiben leer.",
  duplicateBoardCta: "Duplizieren",
  duplicating: "Wird dupliziert …",
  boardDuplicated: "Board dupliziert.",
  boardDescExpand: "Beschreibung ausklappen",
  boardDescCollapse: "Beschreibung einklappen",
  deleteBoard: "Board löschen",
  deleteBoardTitle: "Board wirklich löschen?",
  deleteBoardMessage:
    '„{name}" wird in den Papierkorb verschoben. Du kannst diese Aktion nicht selbst rückgängig machen.',
  boardDeleted: "Board gelöscht.",
  personalBadge: "Persönlich",
  personalBoardHint: "Privat – nur du siehst dieses Board.",
  personalWorkspaceHint: "Privater Bereich – diese Boards siehst nur du.",
  boardArchive: "Archivieren",
  boardUnarchive: "Wiederherstellen",
  boardArchived: "Board archiviert.",
  boardUnarchived: "Board wiederhergestellt.",

  // Workspace rename + delete
  renameWorkspace: "Workspace umbenennen",
  renameWorkspaceTitle: "Workspace umbenennen",
  renameWorkspaceDescription: "Der neue Name ist für alle Mitglieder sofort sichtbar.",
  deleteWorkspace: "Workspace löschen",
  deleteWorkspaceTitle: "Workspace wirklich löschen?",
  deleteWorkspaceMessage:
    '„{name}" und alle {count} enthaltenen Boards werden in den Papierkorb verschoben. Diese Aktion ist nicht selbst rückgängig zu machen.',
  workspaceDeletedToast: "Workspace gelöscht.",

  // Cross-workspace board sharing
  shareBoardMenuItem: "Mit Workspace teilen",
  shareBoardTitle: "Board teilen",
  shareBoardDescription:
    "Wähle Workspaces, deren Mitglieder vollen Zugriff auf dieses Board bekommen.",
  shareBoardCurrent: "Geteilt mit",
  shareBoardNoWorkspaces: "Keine weiteren Workspaces verfügbar.",
  shareBoardHint: "Du kannst nur mit Workspaces teilen, in denen du Mitglied bist.",
  shareBoardAdded: "Board geteilt.",
  shareBoardRemoved: "Freigabe entfernt.",
  sharedBadge: "Geteilt",
  sharedBoardBanner:
    "Dieses Board gehört einem anderen Team und wurde mit deinem Workspace geteilt.",

  // Per-ticket sharing (Phase 4)
  shareRowTitle: "Ticket teilen",
  shareRowDescription:
    "Gib einzelne Personen oder ganze Abteilungen Lesezugriff auf dieses Ticket.",
  shareRowPeopleHd: "Personen",
  shareRowDeptsHd: "Abteilungen",
  shareRowAddPerson: "Person hinzufügen",
  shareRowNoShares: "Noch mit niemandem geteilt.",
  shareRowAdded: "Geteilt.",
  shareRowRemoved: "Freigabe entfernt.",
  shareRowHint:
    "Geteilte sehen nur dieses Ticket — nicht das ganze Board — und können mitlesen und kommentieren.",
  sharedWithLabel: "Geteilt mit",
  memoOriginTooltip: "Zum Protokoll-Abschnitt springen",
  sharedWithYou: "Mit dir geteilt",
  sharedWithYouSub: "Tickets, die andere mit dir oder deiner Abteilung geteilt haben.",
  sharedChipPerson: "mit dir geteilt",
  sharedChipDept: "geteilt mit",

  // Person picker
  assignSearchPlaceholder: "Person suchen…",
  assignEmpty: "Beginne zu tippen, um zu suchen.",
  assignNoResults: "Keine Treffer.",
  assignWillJoinWorkspace: "Wird als Mitglied hinzugefügt",
  assignWillGuestAccess: "Erhält Gast-Zugriff auf dieses Board",
  guestBoardBanner: "Du bist Gast auf diesem Board – du siehst nur die dir zugewiesenen Einträge.",
  guestBadge: "Gast",
  assignTitle: "Personen zuweisen",
  notificationAssigned: "Dir zugewiesen",
  notificationTicketArrived: "Neues Ticket",
  notificationShared: "Mit dir geteilt",
  notificationSharedDept: "Mit deiner Abteilung geteilt",
  notificationFollowUp: "Neues Folgeticket",
  notificationMemoFinalized: "Protokoll finalisiert",
  notificationMemoPrep: "Beitrag zum Protokoll erbeten",

  // Workspace member management
  memberRoleOwner: "Owner",
  memberRoleAdmin: "Admin",
  memberRoleMember: "Mitglied",
  memberRoleViewer: "Viewer",
  memberAdd: "Mitglied hinzufügen",
  memberRemove: "Entfernen",
  memberRemoveTitle: "Mitglied entfernen?",
  memberRemoveMessage: '„{name}" verliert den Zugriff auf diesen Workspace.',
  memberLeaveTitle: "Workspace verlassen?",
  memberLeaveMessage: "Du verlierst den Zugriff auf diesen Workspace.",
  memberLastOwnerError: "Der letzte Owner kann nicht entfernt werden.",
  memberYou: "Du",
  membersSectionEmpty: "Du verwaltest keine Workspaces.",
  membersSectionTitle: "Workspace-Mitglieder",
  membersSectionDescription:
    "Verwalte, wer Zugriff auf deine Workspaces hat. Personen, die einer Person-Spalte zugewiesen werden, werden automatisch als Mitglied hinzugefügt.",

  // Dashboard stat sub-labels
  statsAssignedToMeSub: "Tickets & Zeilen",

  // Workspace color picker
  workspaceColorMenuItem: "Farbe ändern",
  workspaceColorTitle: 'Farbe für „{name}"',
  workspaceColorDescription:
    "Wähle eine Akzentfarbe — sie erscheint überall, wo dieser Workspace farblich markiert wird.",
  workspaceColorAuto: "Automatisch",
  workspaceColorAutoHint: "Auf Basis der Workspace-ID berechnet.",
  workspaceColorSaved: "Farbe gespeichert.",

  // Workspace company (snapshotted onto tickets as "Unternehmen")
  workspaceCompanyMenuItem: "Unternehmen festlegen",
  workspaceCompanyTitle: 'Unternehmen für „{name}"',
  workspaceCompanyDescription:
    "Wird automatisch als Unternehmen auf jedes Ticket übernommen, das Mitglieder dieses Workspace erstellen.",
  workspaceCompanyNone: "Kein Unternehmen",
  workspaceCompanyNoneHint: "Ohne Auswahl bleibt die Spalte Unternehmen leer (—).",
  workspaceCompanySaved: "Unternehmen gespeichert.",

  // Ticket-creation form: rich long-text field placeholder + attach button
  formLongTextHint: "Beschreibung … Screenshots und Dateien hier einfügen oder ablegen",
  formAttachButton: "Bild / Datei anhängen",
  formAttachUploading: "Wird hochgeladen …",
  formAttachRemove: "Entfernen",
  // Shown while a file is dragged over the long-text drop zone.
  formDropHint: "Zum Anhängen hier ablegen",
  // Caption under the Ideenbox "Idee im Namen von" field — most people leave it empty.
  ideaProxyHint: "Nur ausfüllen, wenn die Idee nicht von dir stammt – sonst leer lassen.",
  // Caption under the Ideenbox assignment field. {name} = configured default assignee.
  ideaAssignHint: "Optional – an wen richtet sich die Idee? Ohne Auswahl geht sie an {name}.",
  ideaAssignHintNoDefault: "Optional – an wen richtet sich die Idee?",
  // Ideenbox submit celebration (success state after an idea is filed).
  ideaThanksTitle: "Danke für deine Idee!",
  ideaThanksBody: "Wir schauen sie uns an und melden uns, sobald es etwas Neues gibt.",
  ideaThanksAnother: "Noch eine Idee",
  ideaThanksClose: "Fertig",
  // Ideenbox-Einstellungen dialog (admin: default assignee for unassigned ideas).
  ideenSettingsMenuItem: "Ideenbox-Einstellungen",
  ideenSettingsTitle: "Ideenbox-Einstellungen",
  ideenSettingsDescription: "Lege fest, wer neue Ideen erhält, wenn niemand ausgewählt wurde.",
  ideenDefaultAssigneeLabel: "Standard-Zuständige/r",
  ideenDefaultAssigneeHint: "Erhält jede Idee, bei der die Einreichenden niemanden auswählen.",
  ideenDefaultAssigneeNone: "Niemand ausgewählt – Ideen ohne Auswahl bleiben unzugewiesen.",
  ideenDefaultAssigneeRemove: "Entfernen",
  ideenSettingsSaved: "Einstellung gespeichert.",

  // Phase 6 — Ticket-Einstellungen (category option management)
  ticketSettingsMenuItem: "Ticket-Einstellungen",
  ticketSettingsTitle: "Ticket-Einstellungen",
  ticketSettingsDescription:
    "Verwalte die Auswahl-Optionen dieses Ticket-Boards (Bereich, Priorität, Vorgangstyp).",
  ticketSettingsNoColumns: "Dieses Board hat keine Kategorie-Spalten zum Verwalten.",
  ticketSettingsOptionPlaceholder: "Optionsname",
  ticketSettingsArchiveHint:
    "Archivierte Optionen verschwinden aus den Auswahlfeldern, bleiben aber auf bestehenden Tickets sichtbar.",
  ticketSettingsSaved: "Einstellungen gespeichert.",
  ticketSettingsBlankLabel:
    "Optionen brauchen einen Namen. Leere bestehende Optionen löschst du, indem du sie archivierst.",
  ticketSettingsRequiredLastOption:
    "Die letzte aktive Option eines Pflichtfelds kann nicht archiviert werden.",
  archiveOption: "Archivieren",
  unarchiveOption: "Wiederherstellen",
  manageStatusOptions: "Status-Optionen verwalten",

  // Image lightbox
  lightboxOpenOriginal: "Original öffnen",
  fileDownload: "Herunterladen",

  // Mail viewer (.eml/.msg)
  mailLoading: "Nachricht wird geladen…",
  mailLoadError: "Nachricht konnte nicht geladen werden.",
  mailFrom: "Von",
  mailTo: "An",
  mailCc: "Cc",
  mailDate: "Datum",
  mailAttachments: "Anhänge",
  mailRemoteBlocked: "Externe Inhalte (z. B. Bilder) wurden blockiert.",

  // Topbar workspace switcher
  workspaceSwitcherEmpty: "Noch keine Workspaces",
  workspaceSwitcherTitle: "Workspace wechseln",

  // Command palette
  paletteTitle: "Schnellsuche",
  paletteInputPlaceholder: "Suchen — Workspaces, Boards, Zeilen, Protokolle …",
  paletteMinChars: "Mindestens 2 Zeichen eintippen.",
  paletteSearching: "Wird gesucht …",
  paletteNoResults: "Keine Treffer.",
  paletteGroupWorkspaces: "Workspaces",
  paletteGroupBoards: "Boards",
  paletteGroupRows: "Zeilen",
  paletteGroupComments: "Kommentare",
  paletteGroupMemos: "Protokolle",
  memoFindPlaceholder: "Im Protokoll suchen …",
  memoFindOf: "von",
  memoFindPrev: "Vorheriger Treffer",
  memoFindNext: "Nächster Treffer",
  memoFindClose: "Suche schließen",
  paletteSeriesTag: "Besprechungsreihe",
  paletteMemoRetired: "Zurückgezogen",
  paletteMemoMore: "weitere",
  paletteNav: "Navigieren",
  paletteOpen: "Öffnen",
  paletteClose: "Schließen",

  // Notifications
  notificationsTitle: "Benachrichtigungen",
  notificationsMarkAllRead: "Alle als gelesen markieren",
  notificationsEmpty: "Keine Benachrichtigungen",
  notificationsAll: "Alle anzeigen",
  notificationStatusChanged: "Status geändert",

  // Postfach inbox card
  postfachCardExpand: "Details anzeigen",
  postfachCardCollapse: "Schließen",
  postfachCardUnreadAria: "Neue Aktivität",
  postfachCardNoActivity: "Noch keine Antwort.",
  postfachCardCommentCount: "{count} Kommentare",
  postfachCardCommentCountOne: "1 Kommentar",
  postfachCardSubmittedPrefix: "Eingereicht",
  postfachCardOpenInBoard: "Im Board öffnen",
  postfachCardOpenInBoardHint: "Status, Priorität und weitere Felder bearbeiten",

  // Submit picker (Dashboard section)
  submitPickerTitle: "Anfrage stellen",
  submitPickerSubtitle: "Wähle ein Formular aus.",
  submitPickerCardSub: "Formular öffnen",

  // Mein Postfach
  postfachTitle: "Mein Postfach",
  postfachSubtitle: "Deine eingereichten Anfragen, sortiert nach Datum.",
  postfachEmptyTitle: "Du hast noch keine Anfragen gestellt",
  postfachEmptyHint: "Sobald du ein Formular abschickst, erscheinen deine Einreichungen hier.",
  postfachUntitled: "Anfrage",
  statsMySubmissions: "Meine Anfragen",
  statsMySubmissionsSub: "aktive Anfragen",

  // Submission form
  submitTitle: "Anfrage stellen",
  submitDescription:
    "Fülle das Formular aus. Du erhältst eine Bestätigung, sobald deine Anfrage übermittelt wurde.",
  submitButton: "Übermitteln",
  submitting: "Übermittlung läuft …",
  submitDanke: "Vielen Dank!",
  submitDankeBody:
    "Deine Anfrage wurde übermittelt. Das Team meldet sich, sobald sie bearbeitet wird.",
  submitDankeAnother: "Noch eine Anfrage stellen",
  submitDisabledTitle: "Dieses Board nimmt keine Anfragen entgegen",
  submitDisabledBody:
    "Der Board-Admin muss Anfragen aktivieren, bevor du dieses Formular verwenden kannst.",
  submitNoFields: "Dieses Formular hat aktuell keine ausfüllbaren Felder.",
  submitRequiredField: "Pflichtfeld",
  // Manual ticket creation by a department lead.
  newTicket: "Neues Ticket",
  newTicketDialogTitle: "Neues Ticket anlegen",
  newTicketDialogDescription:
    "Dokumentiere eine Anfrage im Namen einer Person, die selbst keine Nachricht verfassen kann.",
  newTicketButton: "Ticket anlegen",
  newTicketCreated: "Ticket angelegt.",
  discardTitle: "Eingaben verwerfen?",
  discardMessage: "Deine bisherigen Eingaben gehen dabei verloren.",
  discardConfirm: "Verwerfen",
  discardCancel: "Weiter bearbeiten",
  submitLinkUrlPlaceholder: "https://…",
  submitLinkLabelPlaceholder: "Anzeigetext (optional)",
  submitTagsPlaceholder: "Komma-getrennt …",
  personSearchPlaceholder: "Person suchen …",
  submitLinkCopy: "Formular-Link kopieren",
  submitLinkCopied: "Formular-Link kopiert.",
  ideaHomeShow: "Auf Startseite anzeigen",
  ideaHomeHide: "Von Startseite entfernen",
  ideaHomeShown: "Auf der Startseite sichtbar",
  ideaHomeHidden: "Von der Startseite entfernt",

  // Row workflow actions (Phase 10)
  actionBarLabel: "Aktionen",
  actionSendForReview: "Senden zur Prüfung",
  actionClaim: "Annehmen",
  actionWaitingForCustomer: "Wartet auf Kunde",
  actionResolve: "Lösen",
  actionConfirm: "Bestätigen",
  actionReopen: "Erneut öffnen",

  actionDialogTitleSend: "Senden zur Prüfung",
  actionDialogTitleClaim: "Ticket annehmen",
  actionDialogTitleWait: "Wartet auf Kunde setzen",
  actionDialogTitleResolve: "Lösung senden",
  actionDialogTitleConfirm: "Lösung bestätigen",
  actionDialogTitleReopen: "Anfrage erneut öffnen",

  actionBodyLabel: "Kommentar",
  actionBodyPlaceholderSend: "Was soll geprüft werden?",
  actionBodyPlaceholderClaim: "Kurze Nachricht an den Ersteller …",
  actionBodyPlaceholderWait: "Was brauchst du vom Kunden?",
  actionBodyPlaceholderResolve: "Was wurde gelöst?",
  actionBodyPlaceholderConfirm: "Optionaler Kommentar zur Bestätigung",
  actionBodyPlaceholderReopen: "Warum öffnest du die Anfrage erneut?",

  actionRecipientsLabel: "Benachrichtigen",
  actionRecipientsAddMore: "Weitere hinzufügen",
  actionRecipientsCount: "{count} Empfänger",
  actionRecipientsAtLeastOne: "Mindestens ein Empfänger erforderlich.",
  actionRecipientsNoOthers: "Keine weiteren Mitglieder im Workspace.",
  actionRecipientRemove: "Entfernen",

  actionExecuteCta: "Ausführen",
  actionResolveCta: "Lösen",
  actionResolveOutcomeLabel: "Ergebnis",
  actionAssignLabel: "Zuweisen an",
  actionAssignHint: "Pflichtfeld",

  // Activity timeline — phrase shown after the actor's name on a workflow event.
  activityAnnehmen: "hat das Ticket angenommen",
  activitySendenZurPruefung: "hat das Ticket zur Prüfung gesendet",
  activityWartetAufKunde: "hat auf den Kunden gesetzt",
  activityLoesen: "hat das Ticket gelöst",
  activityBestaetigen: "hat die Lösung bestätigt",
  activityErneutOeffnen: "hat das Ticket wieder geöffnet",
  actionReopenCta: "Erneut öffnen",
  actionSubmitFailed: "Aktion fehlgeschlagen.",
  actionStatusColumnMissing:
    "Diese Aktion ist auf diesem Board nicht verfügbar — Status-Spalte fehlt.",

  // Expanded status ladder (Phase 0). sichten/einplanen/zurueckstellen are
  // "leicht": optional note, no notification.
  actionSichten: "Sichten",
  actionEinplanen: "Einplanen",
  actionInReview: "In Review setzen",
  actionZurueckstellen: "Zurückstellen",
  actionDialogTitleSichten: "Ticket sichten",
  actionDialogTitleEinplanen: "Ticket einplanen",
  actionDialogTitleInReview: "In Review setzen",
  actionDialogTitleZurueckstellen: "Ticket zurückstellen",
  actionBodyPlaceholderSichten: "Optionale Notiz …",
  actionBodyPlaceholderEinplanen: "Optionale Notiz …",
  actionBodyPlaceholderInReview: "Was soll im Review geprüft werden?",
  actionBodyPlaceholderZurueckstellen: "Optionale Notiz …",
  activitySichten: "hat das Ticket gesichtet",
  activityEinplanen: "hat das Ticket eingeplant",
  activityInReview: "hat das Ticket in Review gesetzt",
  activityZurueckstellen: "hat das Ticket zurückgestellt",

  // Phase 2: assign-with-message, creator self-close (obsolete), escalate.
  actionAssign: "Zuweisen",
  actionEscalate: "Eskalieren",
  actionHinfaellig: "Hinfällig",
  actionDialogTitleAssign: "Ticket zuweisen",
  actionBodyPlaceholderAssign: "Nachricht an die zugewiesene Person …",
  actionDialogTitleHinfaellig: "Anfrage als hinfällig markieren",
  actionBodyPlaceholderHinfaellig: "Warum ist die Anfrage hinfällig?",
  actionHinfaelligCta: "Als hinfällig markieren",
  actionDialogTitleEskalieren: "Ticket eskalieren",
  actionBodyPlaceholderEskalieren:
    "Warum eskalierst du? Die Abteilungsleitung wird benachrichtigt.",
  actionEskalierenCta: "Eskalieren",
  activityZuweisen: "hat das Ticket zugewiesen",
  activityHinfaellig: "hat die Anfrage als hinfällig markiert",
  activityEskalieren: "hat das Ticket eskaliert",

  // Ideenbox (kind='ideas'): reviewer decision actions on an idea row.
  actionIdeaAssign: "Zur Bewertung zuweisen",
  actionIdeaAccept: "Annehmen",
  actionIdeaReject: "Ablehnen",
  actionDialogTitleAcceptIdea: "Idee annehmen",
  actionBodyPlaceholderAcceptIdea: "Begründung für die Annahme (Pflichtfeld) …",
  actionDialogTitleRejectIdea: "Idee ablehnen",
  actionBodyPlaceholderRejectIdea: "Begründung für die Ablehnung (Pflichtfeld) …",
  activityAnnehmenIdee: "hat die Idee angenommen",
  activityAblehnenIdee: "hat die Idee abgelehnt",

  // Activity timeline (Phase 3) — changelog of direct field edits + lifecycle.
  activityFilterAll: "Alles",
  activityFilterActivity: "Aktivität",
  activityFilterComments: "Kommentare",
  activityEmpty: "Noch keine Aktivität",
  // `noun` = "das Ticket" on ticket boards, "den Eintrag" on normal boards.
  activityCreated: (noun: string) => `erstellte ${noun}`,
  activityRowDeleted: (noun: string) => `löschte ${noun}`,
  activityRowRestored: (noun: string) => `stellte ${noun} wieder her`,
  activitySet: (col: string, val: string) => `setzte ${col} auf ${val}`,
  activityFieldChanged: (col: string, from: string, to: string) =>
    `änderte ${col}: ${from} → ${to}`,
  activityFieldChangedTo: (col: string, to: string) => `änderte ${col} zu ${to}`,
  activityCleared: (col: string) => `entfernte ${col}`,
  activityEdited: (col: string) => `bearbeitete ${col}`,
  activityChecked: (col: string) => `hakte ${col} ab`,
  activityUnchecked: (col: string) => `entfernte den Haken bei ${col}`,
  activityAssigned: (names: string) => `wies ${names} zu`,
  activityUnassigned: (names: string) => `entfernte ${names}`,
  activityShared: (target: string, noun: string) => `teilte ${noun} mit ${target}`,
  activityLinked: (target: string) =>
    target ? `verknüpfte das Ticket mit ${target}` : `verknüpfte das Ticket`,

  // Verknüpfte Tickets (Phase 5)
  linksSectionTitle: "Verknüpfte Tickets",
  linkAction: "Verknüpfen",
  followUpAction: "Folgeticket",
  linksEmpty: "Noch keine Verknüpfungen.",
  linksParentGroup: "Übergeordnet",
  linksFollowUpsGroup: "Folgetickets",
  linksRelatedGroup: "Verknüpft",
  linkRemove: "Verknüpfung entfernen",
  linkDialogTitle: "Ticket verknüpfen",
  linkDialogDescription: "Mit einem anderen Ticket derselben Abteilung verknüpfen.",
  linkDialogRelation: "Beziehung",
  linkDialogSearch: "Ticket suchen",
  linkDialogSearchPlaceholder: "Titel oder ID …",
  linkDialogNoMatches: "Keine passenden Tickets.",
  followUpDialogTitle: "Folgeticket erstellen",
  followUpDialogDescription: "Erstellt ein neues, verknüpftes Ticket in dieser Abteilung.",
  followUpCreateButton: "Folgeticket erstellen",
  followUpCreated: "Folgeticket erstellt",

  // Kanban view
  kanbanNoStatusColumn: "Kanban benötigt eine Status-Spalte auf diesem Board.",
  kanbanGroupByLabel: "Spalten gruppieren nach:",
  kanbanGroupByCategory: "Status (Kategorie)",
  kanbanGroupByGranular: "Status (einzeln)",
  statusBucketTodo: "Zu erledigen",
  statusBucketInWork: "In Arbeit",
  statusBucketDone: "Fertig",
  kanbanNoStatusLane: "Ohne Status",
  kanbanEmptyLane: "Keine Einträge",
  kanbanDropNotAllowed: "Diese Status-Änderung ist hier nicht erlaubt.",
  kanbanCommentsCount: "{count} Kommentare",

  // Settings page
  settingsProfileTitle: "Mein Profil",
  settingsProfileDescription:
    "Anzeige deiner Login-Daten. Bearbeitung folgt — Account-Details werden zentral in Keycloak gepflegt.",
  settingsName: "Name",
  settingsEmail: "E-Mail",
  settingsRoles: "Rollen",
  settingsKeycloakSub: "Keycloak ID",
  settingsThemeTitle: "Darstellung",
  settingsThemeDescription: "Hell oder dunkel — die Wahl wird lokal in diesem Browser gespeichert.",
  themeLight: "Hell",
  themeDark: "Dunkel",
  dateFormatHeading: "Datumsanzeige",
  dateFormatDescription:
    "„Relativ“ zeigt nahe Fristen als „in 5 Tagen“, weiter entfernte als Datum. „Datum“ zeigt Fristen immer als TT.MM.JJJJ. Lokal in diesem Browser gespeichert.",
  dateFormatRelative: "Relativ (in 5 Tagen)",
  dateFormatAbsolute: "Datum (TT.MM.JJJJ)",
  settingsWorkspacesTitle: "Workspaces & Mitglieder",
  settingsWorkspacesDescription: "Mitglieder verwalten und Rollen vergeben. Backend folgt.",
  settingsNotificationsTitle: "Benachrichtigungen",
  settingsNotificationsDescription:
    "Wähle, worüber du per E-Mail informiert wirst. In-App-Benachrichtigungen bleiben immer aktiv.",
  notifPrefsColInApp: "In-App",
  notifPrefsColEmail: "E-Mail",
  notifPrefsDirected:
    "Bei Zuweisung oder @Erwähnung immer benachrichtigen (auch in stummgeschalteten Tickets)",
  notifReasonLabels: {
    assigned: "Mir zugewiesen",
    mention: "@Erwähnungen",
    reply: "Antworten auf meine Kommentare",
    comment: "Neue Kommentare",
    status: "Statusänderungen",
    arrival: "Neue Tickets (für mich als Verantwortliche:n)",
    shared: "Mit mir geteilte Tickets",
    follow_up: "Folgetickets",
    deadline: "Frist nähert sich (bis 7 Tage vorher)",
    deadline_today: "Frist ist heute",
    deadline_overdue: "Frist überschritten (einmalig, am ersten Werktag danach)",
    // Written from the RECIPIENT's side, like every sibling above ("Mir zugewiesen", "Mit mir
    // geteilte Tickets") — these two described the EVENT instead, so they read as system log
    // lines in a list of personal preferences. Product vocabulary is kept verbatim
    // ("Protokoll", "finalisiert", "Besprechung") — the badge on a memo says "Finalisiert", and
    // a settings screen inventing a synonym is how a product starts sounding like two products.
    memo_prep: "Bitte um meinen Beitrag zum Protokoll",
    memo_final: "Finalisierte Protokolle meiner Besprechungen",
  } as Record<string, string>,
  settingsAdminTitle: "Administration",
  settingsAdminDescription: "Nur sichtbar für Mitglieder mit der Rolle flow-admin.",
  settingsAdminUsers: "Nutzer verwalten",
  settingsAdminWorkspaceMgmt: "Workspaces global verwalten",
  // Admin notification defaults
  adminNotifDefaultsHeading: "Standard-Benachrichtigungen",
  adminNotifDefaultsSub:
    "Voreinstellungen für alle Nutzer:innen. Ein Schloss macht die E-Mail verpflichtend – Nutzer:innen können sie dann nicht mehr abschalten.",
  notifMakeObligatory: "Verpflichtend machen",
  notifObligatory: "Verpflichtend (für alle erzwungen)",
  notifLockedByAdmin: "Vom Administrator vorgegeben – kann nicht geändert werden.",
  // Admin backup status panel
  backupHeading: "Datenbank-Backups",
  backupOk: "Backups laufen",
  backupStale: "Kein aktuelles Backup",
  backupNeverRun: "Noch kein Backup vorhanden",
  backupNotConfigured: "Backup-Verzeichnis nicht eingebunden",
  backupNotConfiguredHint:
    "Der Backend-Container sieht /opt/flow/backups nicht. Das ist ein Konfigurationsfehler des Panels, kein fehlendes Backup.",
  backupNewest: "Neuestes Backup",
  backupCount: "Anzahl",
  backupTotalSize: "Gesamtgröße",
  backupLoadError: "Backup-Status konnte nicht geladen werden.",

  back: "Zurück",

  // Monday.com import
  mondayImport: "Von Monday importieren",
  mondayImportTitle: "Import aus Monday.com",
  mondayImportDescription:
    "Hol deine Boards aus Monday.com herüber — Spalten, Zeilen, Untereinträge, Dateien und Kommentare. Nichts geht verloren, es sieht nur aus wie Flow.",
  mondayTokenLabel: "Monday API-Token",
  mondayTokenHint:
    "monday.com → Avatar → Entwickler → Meine Zugriffstokens. Das Token wird nur für diesen Import verwendet und nicht gespeichert.",
  mondayTokenPlaceholder: "Personal API Token einfügen",
  mondayConnect: "Verbinden",
  mondayConnecting: "Verbinde …",
  mondaySelectBoard: "Board auswählen",
  mondayBoardItems: "{count} Einträge",
  mondayOptionsTitle: "Optionen",
  mondayOptionSubitems: "Untereinträge importieren",
  mondayOptionComments: "Updates als Kommentare importieren",
  mondayOptionFiles: "Dateianhänge importieren",
  mondayMappingTitle: "Spalten-Zuordnung",
  mondayMappingSkipped: "übersprungen",
  mondayMappingHint:
    "Prüfe, wie jede Monday-Spalte in Flow landet. Du kannst Spalten umbenennen, den Typ ändern, weglassen oder in eine andere Spalte zusammenführen.",
  mondayMappingAlways: "Wird immer angelegt",
  mondayMappingInclude: "Importieren",
  mondayMappingName: "Flow-Name",
  mondayMappingType: "Typ",
  mondayMappingMerge: "Zusammenführen",
  mondayMappingMergeNone: "Eigene Spalte",
  mondayMappingMergedInto: "→ {name}",
  mondayMappingReset: "Standard wiederherstellen",
  mondayMappingColumnsCount: "{count} Spalten",
  mondayStartImport: "Board importieren",
  mondayImporting: "Importiere … das kann bei großen Boards einen Moment dauern.",
  mondayImportDone: "Import abgeschlossen",
  mondayOpenBoard: "Board öffnen",
  mondayImportAnother: "Weiteres Board importieren",
  mondayReportRows: "Zeilen",
  mondayReportSubitems: "Untereinträge",
  mondayReportCells: "Zellen",
  mondayReportComments: "Kommentare",
  mondayReportFiles: "Dateien",
  mondayReportColumns: "Spalten",
  mondayReportUnmatchedPeople:
    "Nicht zugeordnete Personen (keine Flow-Übereinstimmung per E-Mail):",
  mondayReportDegraded: "Als Text übernommen:",
  mondayReportFilesFailed: "{count} Datei(en) konnten nicht geladen werden.",
  mondayClose: "Schließen",
  // Multi-board batch import
  mondaySelectBoards: "Boards auswählen",
  mondaySelectAll: "Alle",
  mondayDeselectAll: "Keine",
  mondaySelectedCount: "{count} ausgewählt",
  mondayBatchDefaultsNote:
    "Bei mehreren Boards wird die Standard-Zuordnung verwendet. Zum Anpassen einzeln (ein Häkchen) importieren.",
  mondayImportSelected: "{count} Boards importieren",
  mondayBatchRunning: "Importiere {done} / {total} …",
  mondayBatchDone: "{ok} importiert · {failed} fehlgeschlagen",
  mondayBatchPacingHint:
    "Boards werden nacheinander mit kurzer Pause importiert, um Mondays Rate-Limit zu schonen. Bitte das Fenster offen lassen.",
  mondayBatchStatusPending: "Wartet",
  mondayBatchStatusRunning: "Läuft …",
  mondayBatchStatusDone: "Fertig",
  mondayBatchStatusError: "Fehler",

  // Vorlaufzeit / goal date
  columnTypeLeadTime: "Vorlaufzeit",
  leadUnitDays: "Tage",
  leadUnitWeeks: "Wochen",
  leadUnitMonths: "Monate",
  leadSet: "+ Vorlaufzeit",
  leadNoGoalDate: "kein Zieltermin",
  goalDateLabel: "Zieltermin",
  goalDateSet: "Zieltermin setzen",
  goalDateClear: "Zieltermin entfernen",

  // Ideenbox (dedicated /ideen page + nav item)
  navIdeen: "Ideenbox",
  ideenPageTitle: "Ideenbox",
  ideenPageSubtitle: "Reiche eine Idee ein und verfolge deine eigenen Einreichungen.",
  ideenMineHeading: "Meine Ideen",
  ideenMineEmpty: "Du hast noch keine Ideen eingereicht.",

  // Meeting memos (Protokolle)
  navMeetings: "Protokolle",
  meetingsTitle: "Protokolle",
  meetingsSubtitle: "Wiederkehrende Besprechungen und ihre Aufgaben.",
  meetingsEmpty: "Noch keine Besprechungsreihen.",
  meetingsNewSeries: "Neue Besprechungsreihe",
  meetingsKicker: "Wiederkehrende Besprechungen",
  meetingsSearchPlaceholder: "Reihe suchen …",
  meetingsAllAreas: "Alle Bereiche",
  meetingsNoResults: "Keine Reihe gefunden.",
  meetingsLastPrefix: "zuletzt",
  meetingsOpenSuffix: "offen",
  meetingsAllDone: "alles erledigt",
  seriesNewMemo: "Neues Protokoll",
  seriesNoMemos: "Noch keine Protokolle in dieser Reihe.",
  seriesUpcoming: "Anstehend",
  seriesPast: "Vergangen",
  seriesNoUpcomingTitle: "Noch kein nächstes Protokoll angelegt",
  seriesNoUpcomingBody: "Kommentare vom Aufgaben-Board erscheinen erst, sobald es angelegt ist.",
  memoStatusDraft: "Entwurf",
  memoStatusFinalized: "Finalisiert",
  memoStatusUnfinalized: "Nicht finalisiert",
  memoFinalize: "Finalisieren",
  memoReopen: "Wieder öffnen",
  memoDeleteMemo: "Protokoll löschen",
  memoDeleteMemoTitle: "Protokoll löschen?",
  memoDeleteMemoMessage:
    "Dieses Protokoll und seine Einträge werden aus der Reihe entfernt. Die verknüpften Aufgaben bleiben auf dem Board erhalten.",
  memoDeleteMemoConfirm: "Löschen",
  memoDeletedToast: "Protokoll gelöscht.",
  memoEditDate: "Datum ändern",
  memoDateConfirm: "Übernehmen",
  memoDateCancel: "Abbrechen",
  memoDateUpdated: "Datum geändert.",
  memoDateUpdateFailed: "Datum konnte nicht geändert werden.",
  memoRequestPrep: "Um Beiträge bitten",
  memoPrepAlreadyRequested: "Beiträge angefragt",
  memoPrepAlreadyRequestedBy: "Beiträge angefragt · von {name}",
  memoPrepRequested: "Teilnehmer wurden gebeten, ihre Abschnitte zu ergänzen.",
  memoAuditTitle: "Änderungsprotokoll",
  memoAuditEmpty: "Noch keine Änderungen.",
  memoAuditPointLayoutEdited: "hat Leerzeichen, Leerzeilen oder Einrückung eines Punkts geändert",
  memoAuditSubheadingLayoutEdited: "hat Leerzeichen einer Zwischenüberschrift geändert",
  memoAddBlock: "+ Abschnitt",
  memoRenameBlock: "Abschnitt umbenennen",
  memoAddEntry: "+ Eintrag",
  memoAddSubheading: "+ Zwischenüberschrift",
  memoSubheadingPlaceholder: "Zwischenüberschrift…",
  memoSubheadingClose: "Zwischenüberschrift abschließen",
  memoSubheadingCloseTitle: "„{name}“ abschließen?",
  memoSubheadingCloseMessage:
    "Die Zwischenüberschrift und ihre {n} offenen Punkte werden abgeschlossen und erscheinen im nächsten Protokoll nicht mehr.",
  memoSubheadingCloseConfirm: "Abschließen",
  memoRetire: "Punkt abschließen",
  memoUnretire: "Wieder aufnehmen",
  memoRetired: "abgeschlossen",
  memoRevealClosed: "{n} abgeschlossene",
  memoHideClosed: "ausblenden",
  memoRevealHistory: "frühere Punkte",
  memoNewOnly: "Nur Neues",
  memoNewOnlyCaption: "Nur neue Punkte seit dem letzten Protokoll",
  memoNewOnlyEmptyTitle: "Keine neuen Punkte",
  memoNewOnlyEmptyBody: "Seit dem letzten Protokoll wurde nichts Neues ergänzt.",
  memoAsTask: "Als Aufgabe",
  memoTaskDone: "Erledigt",
  // Sub-item rollup on a to-do whose board row was broken down. Count only — the
  // Protokoll never names the sub-assignees: delegating a sub-task must not
  // delegate accountability, the room holds the one person who took the to-do.
  memoSubtaskRollup: "{done} von {total} erledigt",
  memoTaskReopen: "Erneut öffnen",
  memoAssignee: "Verantwortlich",
  memoDueDate: "Fällig",
  memoSolutionLabel: "Lösung",
  memoSolutionPlaceholder: "Kurze Lösungsnotiz (optional)",
  memoSolutionExpand: "Mehr anzeigen",
  memoSolutionCollapse: "Weniger anzeigen",
  memoReadOnlyHint: "Dieses Protokoll ist finalisiert und schreibgeschützt.",
  memoEntryPlaceholder: "Notiz … oder mit @Person am Zeilenanfang eine Aufgabe zuweisen",
  memoPresent: "Präsentieren",
  memoPresentExit: "Präsentation beenden",
  memoPresentFocusHint:
    "↑↓ ←→ Abschnitt · Enter Eintrag · A Aufgabe · Maus: frei scrollen · Esc: zurück",
  memoPresentUnlock: "Bearbeiten entsperren",
  memoPresentUnlocked: "Bearbeiten entsperrt",
  memoPresentHistoryLocked: "Aus einem früheren Protokoll. Oben im Balken „Bearbeiten entsperren“.",
  // A participant has no unlock: only series editors and admins may rewrite history.
  memoHistoryLockedNoRight:
    "Aus einem früheren Protokoll. Nur Bearbeiter der Reihe oder ein Admin können ihn ändern.",
  // Excel puts a bitmap AND an HTML table on the clipboard; both are legitimate.
  pasteChoiceTitle: "Excel-Inhalt einfügen als:",
  pasteAsTable: "Tabelle",
  pasteAsImage: "Bild",
  memoTaskPlaceholder: "@Person + Aufgabe …",
  memoAddTask: "+ Aufgabe",
  // A board-sourced update line. It is attributed to the person who wrote it on the
  // board, so it can only be REMOVED (curation), never rewritten.
  memoUpdateRemove: "Update entfernen",
  memoUpdateUnknownAuthor: "Unbekannt",
  entryDeleted: "Eintrag gelöscht",
  entryRestoreFailed: "Wiederherstellen fehlgeschlagen.",
  memoDeleteBlockTitle: "Abschnitt wirklich löschen?",
  memoMoveBlockFailed: "Abschnitt konnte nicht verschoben werden. Bitte erneut versuchen.",
  // The per-entry "Verschieben nach" menu: Abschnitte with their Zwischenabschnitte indented
  // beneath. Picking an Abschnitt itself means its top level (no Zwischenabschnitt).
  memoMoveTitle: "Verschieben",
  memoMoveTo: "Verschieben nach",
  memoMoveHere: "aktuell",
  memoMoveTopLevelHint: "In den Abschnitt selbst, ohne Zwischenabschnitt",
  memoMoveUntitled: "Ohne Titel",
  memoMoveEntryFailed: "Punkt konnte nicht verschoben werden. Bitte erneut versuchen.",
  // Abschließen / Wieder aufnehmen of a point or a Zwischenüberschrift was refused.
  memoRetireFailed: "Punkt konnte nicht geändert werden. Bitte erneut versuchen.",
  // Saving a point's text, deleting a point or deleting an Abschnitt was refused or never
  // arrived. Without these the failure was silent and an edited text simply vanished.
  memoPatchEntryFailed: "Punkt konnte nicht gespeichert werden. Bitte erneut versuchen.",
  memoDeleteEntryFailed: "Punkt konnte nicht gelöscht werden. Bitte erneut versuchen.",
  memoDeleteBlockFailed: "Abschnitt konnte nicht gelöscht werden. Bitte erneut versuchen.",
  memoDeleteBlockMessage:
    '„{name}" wird mit allen Einträgen entfernt. Verknüpfte Aufgaben im Aufgaben-Board werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
  memoDeleteBlock: "Abschnitt löschen",
  seriesNameLabel: "Name der Reihe",
  seriesWorkspaceLabel: "Workspace",
  seriesSectionsLabel: "Abschnitte",
  seriesParticipantsLabel: "Standard-Teilnehmer",
  seriesTurnusLabel: "Turnus",
  seriesWeekdayNone: "— kein fester Tag",
  seriesEditorsLabel: "Bearbeiter für finalisierte Protokolle",
  memoDateLabel: "Datum",
  memoStartLabel: "Beginn",
  memoEndLabel: "Ende",
  memoLocationLabel: "Ort",
  memoTeamsLinkLabel: "Teams-Link",
  memoFinalizeConfirm:
    "Das Protokoll wird gesperrt; künftige Änderungen sind nur noch für Bearbeiter möglich und werden protokolliert.",
  seriesEdit: "Reihe bearbeiten",
  seriesDelete: "Reihe löschen",
  seriesDeleteTitle: "Besprechungsreihe löschen?",
  seriesDeleteMessage:
    "Die Reihe wird aus der Übersicht entfernt. Bestehende Protokolle, Aufgaben und das verknüpfte Aufgaben-Board bleiben erhalten.",
  seriesDeleted: "Reihe gelöscht.",
  seriesUpdated: "Reihe aktualisiert.",
  seriesTabMemos: "Protokolle",
  seriesTabTasks: "Aufgaben",
  seriesOpenTasksBoard: "Im Board öffnen",
  seriesKicker: "Besprechungsreihe",
  seriesMetaParticipants: "Teilnehmer",
  seriesMetaMemos: "Protokolle",
  seriesMetaMemosSingular: "Protokoll",
  memoSummarySections: "Abschnitte",
  memoSummarySectionSingular: "Abschnitt",
  memoSummaryOpenTaskSingular: "offene Aufgabe",
  memoSummaryOpenTaskPlural: "offene Aufgaben",
  memoSummaryParticipants: "Teilnehmer erfasst",
  taskOriginPrefix: "aus Protokoll",
  taskNoDue: "ohne Frist",
  memoParticipantsEdit: "Teilnehmer bearbeiten",
  memoParticipantsTitle: "Teilnehmer",
  seriesParticipantsTitle: "Teilnehmer der Reihe",
  seriesTasksMine: "Meine Aufgaben",
  seriesTasksOthers: "Weitere Aufgaben",
  seriesTasksOnlyMine: "Nur meine",
  memoParticipantsNone: "Keine Teilnehmer erfasst.",

  // Print / PDF Protokoll (static print components)
  printDraftLabel: "Entwurf",
  printClosedPrefix: "abgeschlossen",
  printDuePrefix: "fällig",
  printParticipants: "Teilnehmer",
  printAction: "Drucken",
  printBack: "Zurück",
  printLoading: "Protokoll wird geladen…",
  printHistoryError: "Einige frühere Punkte konnten nicht geladen werden.",
  memoParticipantsCustomize: "Teilnehmer anpassen",
  memoAttendanceLabel: "Anwesend",
  memoParticipantsUpdated: "Teilnehmer aktualisiert.",
  tasksEmpty: "Noch keine Aufgaben.",
  // On an Aufgaben board a sub-row IS an Aufgabe; on a generic project board it is an Eintrag.
  // Parametrised for the same reason 09a0c02 parametrised "das Ticket" / "den Eintrag": the
  // generic board vocabulary lies about what the row is.
  subtaskAdd: "Unteraufgabe hinzufügen",
  subitemAdd: "Untereintrag hinzufügen",
  subtaskSectionTitle: "Unteraufgaben",
  subtaskNew: "+ Unteraufgabe",
  subtaskOpen: "öffnen",
  subtaskEmpty: "Noch keine Unteraufgaben.",
  // Unteraufgaben section (row detail panel + mobile sheet).
  subtaskAddShort: "Hinzufügen",
  subtaskAssignNobody: "Niemand",
  subtaskTitleLabel: "Titel der Unteraufgabe",
  subtaskDue: "Fällig",
  subtaskDueConfirm: "Übernehmen",
  subtaskDueClear: "Fälligkeit entfernen",
  subtaskCreateFailed: "Unteraufgabe konnte nicht angelegt werden.",
  // Ticket boards: the workflow status is action-only (comment + recipient + notification,
  // and a closed option stamps resolved_at), so the sub-task tick becomes a read-only pill.
  subtaskStatusReadOnly: "Status nur über Aktionen änderbar",
  // Move a sub-item elsewhere via the menu fallback (reparent or promote).
  moveSubitemTitle: "Verschieben nach …",
  moveUnderEntry: "Unter Eintrag einordnen",
  movePromotePrefix: "Als eigener Eintrag in", // + " <Header>"
  movePromoteNoGroup: "Als eigener Eintrag (oberste Ebene)",
  rowCopyTitle: "Kopieren",
  rowCopyUnderEntry: "Kopieren unter",
  rowCopyIntoGroup: "Kopieren in Gruppe",
  groupDuplicateTitle: "Gruppe duplizieren",
  groupDuplicateDescription:
    "Alle Einträge dieser Gruppe (inkl. Untereinträge) werden in eine neue Gruppe kopiert.",
  groupDuplicateNameLabel: "Name der neuen Gruppe",
  groupDuplicateConfirm: "Duplizieren",
  groupDeleteTitle: "Gruppe löschen",
  groupDeleteMessage: (label: string, rows: number, subitems: number, hidden: number) =>
    `Die Gruppe „${label}“ wird mit ${rows === 1 ? "1 Eintrag" : `${rows} Einträgen`}` +
    (subitems > 0
      ? ` und ${subitems === 1 ? "1 Untereintrag" : `${subitems} Untereinträgen`}`
      : "") +
    " gelöscht." +
    (hidden > 0
      ? ` Davon ${hidden === 1 ? "ist 1 Eintrag" : `sind ${hidden} Einträge`} gerade durch einen Filter ausgeblendet.`
      : "") +
    " Mit Strg+Z rückgängig.",
  groupDeleted: "Gruppe gelöscht – mit Strg+Z rückgängig",
  groupDeletePartial: (failed: number) =>
    `${failed === 1 ? "1 Eintrag konnte" : `${failed} Einträge konnten`} nicht gelöscht werden – die Gruppe bleibt bestehen.`,
  bulkSetField: "Feld setzen",
  bulkApply: "Übernehmen",
  bulkClearValue: "Leeren",
  bulkPickPeople: "Personen wählen",
  bulkNoValue: "Kein Wert gewählt",
} as const;

export type Strings = typeof t;
